import emailjs from '@emailjs/browser';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import check from '../../assets/img/check.png';
import checked from '../../assets/img/checked.png';
import Input from '../global/Input';

const SubmitForm = () => {
  const navigate = useNavigate();

  const [isLinkHovered, setIsLinkHovered] = useState(false);
  const [projectDescription, setProjectDescription] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [phone, setPhone] = useState("");
  const [position, setPosition] = useState("");
  const [email, setEmail] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLinkMouseOver = () => {
    setIsLinkHovered(true);
  };

  const handleLinkMouseLeave = () => {
    setIsLinkHovered(false);
  };

  const onNameHandler = (e) => {
    setName(e.target.value);
  };
  const onCompanyHandler = (e) => {
    setCompany(e.target.value);
  };
  const onPhoneHandler = (e) => {
    setPhone(e.target.value);
  };
  const onPositionHandler = (e) => {
    setPosition(e.target.value);
  };

  const onEmailHandler = (e) => {
    setEmail(e.target.value);
  };

  const fileInput = useRef(null);

  const handleButtonClick = () => {
    fileInput.current.click();
  };

  const handleChange = (e) => {
    const newFiles = e.target.files;
    setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleDeleteFile = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    if (projectDescription.length === 0) {
      alert('프로젝트 설명은 필수 입력입니다.')
    } else if (name.length === 0) {
      alert('이름은 필수 입력입니다.')
    } else if (phone.length === 0) {
      alert('연락처는 필수 입력입니다.')
    } else if (email.length === 0) {
      alert('이메일은 필수 입력입니다.')
    } else if (!validateEmail(email)) {
      alert('유효한 이메일 주소를 입력해주세요.')
    } else if (!isAgreed) {
      alert('개인정보 수집에 동의를 안하시면 이용하실 수 없습니다.')
    } else {
      try {
        setIsSubmitting(true);

        const response = await emailjs.send("service_uowd3zy", "template_qdlbb7l", {
          info: projectDescription,
          name: name,
          company: company,
          position: position,
          phone: phone,
          email: email
        }
        );

        if (response.status === 200) {
          alert("이메일 전송에 성공하였습니다.");
          navigate('/#sec1');
        } else {
          throw new Error('서버 응답이 실패했습니다.');
        }
      } catch (error) {
        console.error("error", error);
        if (error.code === 'ECONNABORTED') {
          alert('요청 시간이 초과되었습니다. 다시 시도해주세요.');
        } else if (error.response) {
          alert(`이메일 전송 실패: ${error.response.data.message || '서버 오류가 발생했습니다.'}`);
        } else if (error.request) {
          alert('서버에 연결할 수 없습니다. 네트워크 연결을 확인해주세요.');
        } else {
          alert('이메일 전송 중 오류가 발생했습니다.');
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  };


  const handleSetValue = (e) => {
    setProjectDescription(e.target.value);
  };

  useEffect(() => {
    emailjs.init('2EGmBSkQst6FNZfTf');
  }, []);

  return (
    <SubmitBox>
      <form onSubmit={handleSubmit}>
        <div className='action'>
          <p>1. 프로젝트 정보</p>
          <ul>
            <li>
              <p>프로젝트 설명</p>
              <textarea cols="30" rows="10" value={projectDescription} onChange={handleSetValue} placeholder='프로젝트 설명을 입력해 주세요.'></textarea>
            </li>
            {/* <li>
              <p>파일 첨부 <span>(선택)</span></p>
              <button type='button' className='fileBtn' onClick={handleButtonClick}>클릭하여 파일 업로드</button>
              <input type="file"
                ref={fileInput}
                onChange={handleChange}
                style={{ display: "none" }} />
              <div className='fileBox'>
                {selectedFiles.map((file, index) => (
                  <div key={index}>
                    <span>{file.name}
                      <button
                        type='button'
                        className='delFile'
                        onClick={() => handleDeleteFile(index)}
                      >
                        <IoMdClose />
                      </button>
                    </span>

                  </div>
                ))}
              </div>
            </li> */}
          </ul>
        </div>
        <div className='action'>
          <p>2. 인적사항</p>
          <ul>
            <li>
              <ol>
                <li>
                  <p>
                    성명
                  </p>
                  <Input name={'name'} value={name} onChange={onNameHandler} placeholder={'성명을 입력해 주세요.'} />
                </li>
                <li>
                  <p>
                    회사명 <span>(선택)</span>
                  </p>
                  <Input name={'company'} value={company} onChange={onCompanyHandler} placeholder={'회사명을 입력해 주세요.'} />
                </li>
              </ol>
            </li>
            <li>
              <ol>
                <li>
                  <p>
                    연락처
                  </p>
                  <Input name={'phone'} value={phone} onChange={onPhoneHandler} placeholder={'연락처를 입력해 주세요.'} />
                </li>
                <li>
                  <p>
                    직책 <span>(선택)</span>
                  </p>
                  <Input name={'position'} value={position} onChange={onPositionHandler} placeholder={'직책을 입력해 주세요.'} />
                </li>
              </ol>
            </li>
            <li>
              <p>
                이메일
              </p>
              <Input name={'email'} value={email} onChange={onEmailHandler} placeholder={'이메일을 입력해 주세요.'} />
            </li>
            <li className='submitBox'>
              <div className='checkboxWrap'>
                <input type="checkbox" id='check' value={isAgreed} onChange={(e) => setIsAgreed(e.target.checked)} /><label htmlFor="check">개인정보 수집 동의</label>
              </div>
              <button type="submit"
                disabled={isSubmitting}
                onMouseOver={handleLinkMouseOver}
                onMouseLeave={handleLinkMouseLeave}
                className={isLinkHovered ? 'hovered-link submitBtn' : 'submitBtn'}>
                {isSubmitting ? '제출 중...' : '의뢰하기'}
              </button>
            </li>
          </ul>
        </div>
      </form>
    </SubmitBox>
  );
};

const SubmitBox = styled.div`
  margin-top:60px; 
  border-top: 0.5px solid #fff;
  padding:50px 0 100px;
  form{
    >div{
      display: flex;
      justify-content: space-between;
      margin-bottom: 50px;
    }
  }
  textarea{
    padding:20px;
    border-radius: 3px;
    border: 0.5px solid #fff; 
    background-color: transparent;
    width: 100%;
    color:#fff;
    margin-bottom: 20px;
    opacity: 0.6;
    &:focus-visible{
      opacity: 1;
    }
  }
  p{
    font-size: 20px;
    color:#fff; 
    margin-bottom: 10px;
    span{
      font-size: 16px;
    }
  }
  .fileBtn{
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.50);
    width: 100%;
    height: 66px;
    padding:20px;
    transition: all 0.3s;
    font-size: 20px;
    font-weight: 600;
    &:hover{
      background: rgba(255, 255, 255, 1);
    }
    }
    .checkboxWrap{
      position: relative;
    }
    #check{
        display: none;
      }
      #check + label::before{
        content: "";
        display: inline-block;
        width: 24px;
        height: 24px;
        background-image: url(${check});
        margin-right:13px;
      }
      #check:checked+ label::before{
        background-image: url(${checked});
      }
  .submitBtn{
    border-radius: 3px;
    background: #fff;
    width: 100%;
    height: 66px;
    padding:20px;
    font-size: 20px;
    font-weight: 600;
    color:#000;
    margin-top:20px;
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
  .fileBox{
    span{
      padding:5px 0 ;
      display: flex;
      color: #fff;
      align-items: center;
    }
    .delFile{
      color:#fff;
      padding-left: 8px;
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  ul{
    width: 675px;
    ol{
      display: flex;
      gap:20px;
      li{
        width: 50%;
        margin-bottom: 20px;
      }
    }
  }
  .submitBox{
    margin-top:50px;
    label{
      font-size: 20px;
      color:#fff; 
      display: flex;
    align-items: center;
    }
  }
`;

export default SubmitForm;